module.exports = __webpack_public_path__ + "static/5_1-brain-28a6ad2f98e4959fef79682877ff5da6.svg";